import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function LoadErrorAlert() {
    return (<Alert appearance="danger" message={t({
            message: 'Something went wrong, please try again later',
            comment: 'Error message for not being able to load external sharing section',
        })}/>);
}
